module.exports = __webpack_public_path__ + "img/dianliang1.875030f3.png";